import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { TabMenu } from "primereact/tabmenu";
import PageContainer from "../../Components/Page/PageContainer";
import { ROUTES } from "../../config/routes";

const ClaimPolicyPatchDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes(ROUTES.CLAIM_POLICY_PATCH_DASHBOARD_UPDATED_CLAIMS)) {
      setActiveIndex(1);
    } else {
      setActiveIndex(0);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === ROUTES.CLAIM_POLICY_PATCH_DASHBOARD) {
      navigate(ROUTES.CLAIM_POLICY_PATCH_DASHBOARD_OVERVIEW, { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (e: { index: number }) => {
    if (e.index === 1) {
      navigate(ROUTES.CLAIM_POLICY_PATCH_DASHBOARD_UPDATED_CLAIMS);
      return;
    }
    navigate(ROUTES.CLAIM_POLICY_PATCH_DASHBOARD_OVERVIEW);
  };

  const items = [
    { label: "Dashboard", icon: "pi pi-chart-line" },
    { label: "Updated Claims", icon: "pi pi-list" },
  ];

  return (
    <PageContainer
      HomeMenuBarprops={{
        title: "Claim Policy Patch Dashboard",
        Tabs: (
          <TabMenu
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            model={items}
          />
        ),
      }}
    >
      <div style={{ width: "96%", margin: "0 auto" }}>
        <Card
          unstyled
          style={{
            marginTop: "2rem",
            boxShadow: "none",
          }}
        >
          <Outlet />
        </Card>
      </div>
    </PageContainer>
  );
};

export default ClaimPolicyPatchDashboard;
